import styled from "styled-components";

export const AdminLayout = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  box-sizing: border-box;
  min-height: 100vh;
`;
